<template>
  <div>
    <v-icon color="pageHeader" small left>mdi-view-agenda</v-icon>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs"
        v-on="on" 
        style="color: var(--v-primary-base); 
        font-weight: 700">
        {{ item.agendaName }}
      </span>
      </template>
      <span>{{ $t("menu.agenda") }}</span>
    </v-tooltip>
    
    <ul>
      <li
        v-for="(topic, index) in item.topics"
        :key="index"
        :style="`color:${textColor}; max-width:350px;`"
      >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span 
          v-bind="attrs"
          v-on="on" 
          >
          {{ topic.topicName }}
        </span>
        </template>
        <span>{{ $t("topic") }}</span>
      </v-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AgendaSearchTopicItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isDeleted: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    textColor() {
      return "var(--v-neutralGray-darken2)";
    },
  },
};
</script>

<style>
</style>